import { render, staticRenderFns } from "./AdsManager.vue?vue&type=template&id=5d2c432b&scoped=true&"
import script from "./AdsManager.vue?vue&type=script&lang=ts&"
export * from "./AdsManager.vue?vue&type=script&lang=ts&"
import style0 from "./AdsManager.vue?vue&type=style&index=0&id=5d2c432b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d2c432b",
  null
  
)

export default component.exports